import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Spinner from './spinner'

class Preloader extends PureComponent {
  render() {
    const { loading, children } = this.props

    if (loading) {
      return <Spinner loading />
    }

    return children
  }
}

Preloader.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.node,
}

Preloader.defaultProps = {
  loading: false,
  children: null,
}

export default Preloader
